import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    main: {
        margin: "2rem 1rem",
    },
}));

export default useStyles;
